import * as React from "react";
const SvgMultiRole = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 51, viewBox: "0 0 48 51", fill: "none", ...props }, "...");
export default SvgMultiRole;
